import styled from '@emotion/styled';
import TestSelectors from '@racemap/utilities/consts/test_selectors';
import { NotActivatedOverlay } from 'src/components/BasicComponents/NotActivatedOverlay/NotActivatedOverlay';
import { LeaderboardHeader } from 'src/components/Leaderboard/Header';
import { Leaderboard } from 'src/components/Leaderboard/Leaderboard/Leaderboard';
import { LeaderboardFooter } from 'src/components/Leaderboard/LeaderboardFooter';
import { checkLeaderboardActivationState } from 'src/components/Leaderboard/utils';
import {
  useIsFirstLoad,
  useIsLoading,
  useLoadError,
  useParentEventData,
  useRelevantEventsData,
  useSelectedEventData,
  useSelectedEventId,
} from 'src/store/leaderboard/leaderboard_reducer';
import { LeaderboardErrorPage } from './LeaderboardErrorPage';

type OuterLeaderBoardProps = {
  design?: 'standard' | 'slim' | 'compact';
  onSelectedEventChange?: (newEventId: string, newSlug?: string) => void;
};

export function OuterLeaderBoard({
  design = 'standard',
  onSelectedEventChange,
}: OuterLeaderBoardProps) {
  const relevantEvents = useRelevantEventsData();
  const selectedEventId = useSelectedEventId();
  const loading = useIsLoading();
  const isFirstLoad = useIsFirstLoad();
  const loadError = useLoadError();
  const selectedEventData = useSelectedEventData();
  const parentEventData = useParentEventData();
  const selectedEvent = selectedEventData?.eventObject;
  const parentEvent = parentEventData?.eventObject;
  const { isArchived, isModuleActivated, isEventAuthorized } = checkLeaderboardActivationState(
    selectedEvent || null,
  );

  return (
    <>
      <LeaderboardHeader
        events={Array.from(relevantEvents.values()).map((e) => e.eventObject)}
        selectedEventId={selectedEventId}
        parentEvent={parentEvent}
        onSelectedEventChange={onSelectedEventChange}
        loading={loading}
      />
      {!loadError && (isFirstLoad || (!isArchived && isModuleActivated)) ? (
        <LeaderBoardContainer design={design}>
          <Leaderboard />
          {design !== 'compact' && !isFirstLoad && <LeaderboardFooter />}
        </LeaderBoardContainer>
      ) : (
        <LeaderboardErrorPage event={selectedEvent} loadError={loadError} />
      )}

      {!loadError && !isEventAuthorized && !isArchived && isModuleActivated && (
        <NotActivatedOverlay
          className={TestSelectors.leaderboard.mapNotActivatedOverlay.toString()}
        />
      )}
    </>
  );
}

const LeaderBoardContainer = styled.div<{ design: 'standard' | 'slim' | 'compact' }>`
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;

  @media screen and (min-width: 576px) {
    padding-left: 30px;
    padding-right: 30px;
  }

  @media screen and (min-height: 800px) {
    padding-top: 20px;
    padding-bottom: 20px;
  }

  ${({ design }) => {
    if (design === 'compact') {
      return 'padding: 0 !important;';
    }
    if (design === 'slim') {
      return 'padding: 10px !important;';
    }
  }}
`;
